import axios from 'axios';
import config from '../config/2026.json';

const MONTREAL_API_BASE = 'https://donnees.montreal.ca/api/3/action/datastore_search';
const isDev = process.env.NODE_ENV !== 'production';
const debugLog = (...args) => {
  if (isDev) console.log(...args);
};

export const searchDwellings = async (streetName, civicNumber) => {
  try {
    const searchQuery = `${civicNumber} ${streetName}`;
    const params = {
      resource_id: config.dwellingsResourceId,
      q: searchQuery,
      limit: 100
    };
    
    debugLog('Dwellings API query:', searchQuery);

    const response = await axios.get(MONTREAL_API_BASE, { params });
    
    if (!response.data?.result?.records) {
      return { success: false, error: 'no_data', dwellings: null };
    }

    const records = response.data.result.records;
    const civicNum = parseInt(civicNumber, 10);

    const matchingRecord = records.find(record => {
      const start = parseInt(String(record.CIVIQUE_DEBUT).trim(), 10);
      const end = parseInt(String(record.CIVIQUE_FIN).trim(), 10);
      
      debugLog('Dwellings matching:', { civicNum, start, end, CIVIQUE_DEBUT: record.CIVIQUE_DEBUT, CIVIQUE_FIN: record.CIVIQUE_FIN });
      
      if (isNaN(start) || isNaN(end)) {
        return String(record.CIVIQUE_DEBUT).trim() === String(civicNumber);
      }
      
      return civicNum >= start && civicNum <= end;
    });

    if (matchingRecord) {
      const dwellingCount = parseInt(matchingRecord.NOMBRE_LOGEMENT, 10) || 1;
      return {
        success: true,
        dwellings: dwellingCount,
        source: 'api',
        record: matchingRecord
      };
    }

    return {
      success: false,
      error: 'no_match',
      dwellings: null
    };

  } catch (error) {
    console.error('Error fetching dwellings data:', error);
    return {
      success: false,
      error: 'api_error',
      dwellings: null,
      message: error.message
    };
  }
};

export const getDwellingsForAddress = async (arrondissement, streetName, civicNumber) => {
  const result = await searchDwellings(streetName, civicNumber);
  
  return {
    ...result,
    arrondissement,
    streetName,
    civicNumber
  };
};
